Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityTableView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_table']
  className: 'operator-availability-table'

  initialize: ({reportItems, pendingTicketsIncluded}) ->
    @reportItems = reportItems
    @pendingTicketsIncluded = pendingTicketsIncluded
    @headerView = new Customer.Views.Reports.OperatorAvailabilityTableHeaderView(pendingIncluded: @pendingTicketsIncluded)

  render: =>
    @$el.html(@template())
    @_renderTableHeader()
    @renderTableBody()
    @_renderTablePlaceholder()
    @

  _renderTableHeader: =>
    @$el.find('.operator-availability-table-header').html(@headerView.render().el)

  renderTableBody: =>
    $tableBody = @$el.find('.operator-availability-table-body')
    $tableBody.empty()
    @reportItems.forEach (reportItem) =>
      rowView = new Customer.Views.Reports.OperatorAvailabilityTableRowView(reportItem: reportItem, pendingIncluded: @pendingTicketsIncluded)
      $tableBody.append(rowView.render().el)

  _renderTablePlaceholder: =>
    $tableBody = @$el.find('.operator-availability-table-placeholder-body')
    headerHeight = 188
    tableSectionHeight = window.innerHeight - headerHeight
    rowPlaceholderHeight = Customer.Views.Reports.OperatorAvailabilityTableRowPlaceholder.contentHeight
    rowPlaceholderAmount = Math.floor(tableSectionHeight / rowPlaceholderHeight) + 1
    @_appendPlaceholderRow($tableBody) for [1..rowPlaceholderAmount]

  _appendPlaceholderRow: ($tableBody) =>
    rowView = new Customer.Views.Reports.OperatorAvailabilityTableRowPlaceholder(pendingIncluded: @pendingTicketsIncluded)
    $tableBody.append(rowView.render().el)

  displayLoadedContent: =>
    @$el.find('.operator-availability-table-placeholder-body').hide()
    @$el.find('.operator-availability-table-body').show()

  displayPlaceholderContent: =>
    @$el.find('.operator-availability-table-body').hide()
    @$el.find('.operator-availability-table-placeholder-body').show()
